import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';

import useFeedbackRatingDistribution from '../../../hooks/dashboard/driver-list/useFeedbackRatingDistribution';
import {
  StarFilterDataType,
  StarFilterSchema,
  StarFilterSchemaInitialValues,
} from '../../../models/dashboard/filter-forms/star-filter.model';
import {
  CustomStarInlineRadioCustomFieldGroup,
  CustomStarRadio,
} from '../../FormCom/CustomStarInlineRadioCustomField';
import { FormComponent } from '../../FormCom/FormComponent';
import { TableContext } from '../TableContext';

interface CustomStarFilterFormProps {}

const CustomStarFilterForm: React.FC<CustomStarFilterFormProps> = () => {
  const { driverId } = useParams();
  const tableContext = useContext(TableContext);
  const { getFeedbackRatingDistribution, feedbackDistributionData } =
    useFeedbackRatingDistribution();
  const [formInitialState, setFormInitialState] = useState<StarFilterDataType>(
    {},
  );

  useEffect(() => {
    setFormInitialState({
      ...StarFilterSchemaInitialValues,
      ...tableContext?.tableSelectedFilter,
    });
  }, [tableContext?.tableSelectedFilter]);

  useEffect(() => {
    getFeedbackRatingDistribution({
      driverId: driverId ?? '',
    });
    // eslint-disable-next-line
  }, [driverId]);

  if (Object.keys(formInitialState).length === 0) {
    return <div>'...'</div>;
  }

  const handleOnSubmit = (values: StarFilterDataType) => {
    tableContext?.setTableSelectedFilter((prevFilter: StarFilterDataType) => ({
      ...prevFilter,
      ...values,
    }));
    tableContext?.handleSetTableFilterRecord({
      ...values,
      // 'All' means no rating filter, so clear it instead of sending it in the query string
      rating: values.rating === 'All' ? '' : values.rating,
      page: 0,
    });
  };

  const handleFieldChange = (fieldName: keyof StarFilterDataType) => {
    return (value: string) => {
      setFormInitialState((prevFilter) => ({
        ...prevFilter,
        [fieldName]: value,
      }));
      tableContext?.setTableSelectedFilter(
        (prevFilter: StarFilterDataType) => ({
          ...prevFilter,
          [fieldName]: value,
        }),
      );
      tableContext?.handleSetTableFilterRecord({
        // 'All' means no rating filter, so clear it instead of sending it in the query string
        [fieldName]: value === 'All' ? '' : value,
        page: 0,
      });
    };
  };

  return (
    <FormComponent
      initialValues={formInitialState}
      schema={StarFilterSchema}
      onSubmit={handleOnSubmit}
    >
      <CustomStarInlineRadioCustomFieldGroup
        name='rating'
        onChange={handleFieldChange('rating')}
      >
        {feedbackDistributionData?.map((item) => (
          <CustomStarRadio
            key={item.name}
            name='rating'
            value={String(item.name)}
            starCount={item.value}
            starNumber={item.name === 'All' ? undefined : Number(item.name)}
          />
        ))}
      </CustomStarInlineRadioCustomFieldGroup>
    </FormComponent>
  );
};

export default CustomStarFilterForm;
